import { memo } from 'react'

import { BidAuctionIcon, ConstructionIcon, HandshakeIcon, MapIcon } from 'components/new-icons'
import { OtherProducts } from 'modules/other-products'

const products = [
  {
    link: '/emprestimo-para-empresa/',
    title: 'Empréstimo para Empresas',
    description: 'Tenha capital de giro alto e rápido para potencializar o lucro do seu negócio.',
    icon: BidAuctionIcon
  },
  {
    link: '/financiamento-para-construcao/',
    title: 'Crédito para Construção',
    description: 'Comece ou termine a obra com crédito de até 50% do valor do imóvel pronto.',
    icon: ConstructionIcon
  },
  {
    link: '/emprestimo-com-garantia-de-terreno/',
    title: 'Empréstimo com Garantia de Terreno',
    description: 'Use um terreno urbano como garantia e tenha acesso a crédito livre.',
    icon: MapIcon
  },
  {
    link: '/financiamento-imobiliario/',
    title: 'Financiamento Imobiliário SFI',
    description: 'Financie o imóvel que desejar com flexibilidade e condições personalizadas.',
    icon: HandshakeIcon
  }
]

export const CondominiumCreditOtherProducts = memo(() => (
  <OtherProducts products={products} dataLayerAction="Crédito para Condomínios" />
))

CondominiumCreditOtherProducts.displayName = 'CondominiumCreditOtherProducts'
